// export const BaseGatewayImage = 'http://localhost:8282';
// const BaseGateway = 'http://localhost:8282/api/v1';

// export const BaseGatewayImageAuth = 'http://localhost:8383';
// const BaseGatewayAuth = 'http://localhost:8383/api/v1';


//export const BaseGatewayImage = 'https://localhost:5001';
//const BaseGateway = 'https://localhost:5001/api/v1';

//export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
//export const BaseGatewayAuth = 'https://localhost:5003';

// build deploy
 export const BaseGatewayImage = 'https://api.quanlycongviec.cntt108.vn';
 export const BaseGateway = 'https://api.quanlycongviec.cntt108.vn/api/v1';

 export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
 export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';

// local test
// export const BaseGatewayImage = 'https:localhost:5001';
// const BaseGateway = 'https:localhost:5001/api/v1';

// export const BaseGatewayAuthApi = 'https:localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https:localhost:5003';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const BaseGatewayClient = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguồn 
export const AUTH_API = {
  LOGIN_API: `${BaseGatewayAuth}/connect/token`,
  REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
  CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Account/ChangePassword`,
  FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
  RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
  GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
  ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
  EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
  DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
  GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
  COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`
};

export const OPENIDDICTAPPLICATION_API = {
  GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
  GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
  ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
  UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
  DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

export const FILE_MANAGER_API = {
  UPLOAD: `${BaseGateway}/FileManager/Upload`,
  GET_PAGING: `${BaseGateway}/FileManager/GetAllByPaging`,
  GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
  DELETE: `${BaseGateway}/FileManager`
};

export const EMAILCONFIG_API = {
  GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
  GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
  ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
  UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
  DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
  GET_PAGING_LOGIN: `${BaseGateway}/LoginHistory/GetAllPaging`,
  STATISTIC_LOGIN: `${BaseGateway}/LoginHistory/GetStatisticsLoginByAccount`,
  STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGateway}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
  GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
  DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
  COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};

export const APIROLEMAPPING_API = {
  GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
  GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
  ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
  UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
  DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
  BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

export const ROLE_API = {
  GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
  GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
  GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
  ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
  UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
  DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
  UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const MENU_API = {
  GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
  GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
  GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
  ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
  UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
  DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
  UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const BOPHAN_API = {
  BASE: `${BaseGateway}/BoPhan/GetAll`,
  BY_ID: `${BaseGateway}/BoPhan/GetById`,
  CREATE: `${BaseGateway}/BoPhan/Create`,
  UPDATE: `${BaseGateway}/BoPhan/Update`,
  DELETE: `${BaseGateway}/BoPhan/Delete`,
};

export const TEAM_API = {
  BASE: `${BaseGateway}/Team/GetAll`,
  BY_ID: `${BaseGateway}/Team/GetById`,
  CREATE: `${BaseGateway}/Team/Create`,
  UPDATE: `${BaseGateway}/Team/Update`,
  DELETE: `${BaseGateway}/Team/Delete`,
};

export const NHANVIEN_API = {
  BASE: `${BaseGateway}/NhanVien/GetAll`,
  BY_ID: `${BaseGateway}/NhanVien/GetById`,
  CREATE: `${BaseGateway}/NhanVien/Create`,
  UPDATE: `${BaseGateway}/NhanVien/Update`,
  DELETE: `${BaseGateway}/NhanVien/Delete`,
};

export const NGUOIDUNG_API = {
  GET_ALL: `${BaseGateway}/NguoiDung/GetAll`,
  GET_AVAILABLE_FOR_NHANVIEN: `${BaseGateway}/NguoiDung/GetAvailableForNhanVien`,
  SYNC_FROM_ACCOUNT: `${BaseGateway}/NguoiDung/SyncFromAccount`,
  GET_BY_ACCOUNT_ID: (accountId) =>
    `${BaseGateway}/NguoiDung/GetByAccountId/${accountId}`,
  GET_BY_ID: (id) =>
    `${BaseGateway}/NguoiDung/GetById/${id}`,
};

export const KHOA_API = {
  GET_ALL: `${BaseGateway}/Khoa/GetAll`,
  GET_PAGING: `${BaseGateway}/Khoa/GetAllByPaging`,
  GET_ITEM: (id) => `${BaseGateway}/Khoa/GetById/${id}`,
  ADD_ITEM: `${BaseGateway}/Khoa/Create`,
  UPDATE_ITEM: (id) => `${BaseGateway}/Khoa/Update/${id}`,
  DELETE_ITEM: (id) => `${BaseGateway}/Khoa/Delete/${id}`,
  SYNC_KHOA: `${BaseGateway}/Khoa/SyncKhoaFromDonVi`,
};

export const QUYTRINH_API = {
  BASE: `${BaseGateway}/QuyTrinh/GetAll`,
  BY_ID: `${BaseGateway}/QuyTrinh/GetById`,
  CREATE: `${BaseGateway}/QuyTrinh/Create`,
  UPDATE: `${BaseGateway}/QuyTrinh/Update`,
  DELETE: `${BaseGateway}/QuyTrinh/Delete`,
};

export const PROJECT_API = {
  BASE: `${BaseGateway}/Project/GetAll`,
  BY_ID: `${BaseGateway}/Project/GetById`,
  CREATE: `${BaseGateway}/Project/Create`,
  UPDATE: `${BaseGateway}/Project/Update`,
  DELETE: `${BaseGateway}/Project/Delete`,
  UPDATE_STATUS: (id) => `${BaseGateway}/Project/UpdateStatus/${id}/status`,
  GET_ALL_PAGING: `${BaseGateway}/Project/GetAllByPaging`,
  ADD_FILE: `${BaseGateway}/Project/AddFile`,
  DELETE_FILE: `${BaseGateway}/Project/DeleteFile`,
  GET_FILES_BY_PROJECT: `${BaseGateway}/Project/GetFilesByProjectId`,
  DOWNLOAD_FILE: (fileId) =>
    `${BaseGateway}/Project/DownloadFile/${fileId}/download`,
};

export const PROJECT_STEP_API = {
  GET_ALL: `${BaseGateway}/ProjectStep/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/ProjectStep/GetById/${id}`,
  BY_PROJECT: (projectId) =>
    `${BaseGateway}/ProjectStep/GetSummaryByProjectId/${projectId}`,
  UPDATE_STATUS: `${BaseGateway}/ProjectStep/UpdateStatus`,
};

export const LINHVUC_API = {
  GET_ALL: `${BaseGateway}/LinhVuc/GetAll`,
  GET_ITEM: (id) => `${BaseGateway}/LinhVuc/GetById/${id}`,
  ADD_ITEM: `${BaseGateway}/LinhVuc/Create`,
  UPDATE_ITEM: (id) => `${BaseGateway}/LinhVuc/Update/${id}`,
  DELETE_ITEM: (id) => `${BaseGateway}/LinhVuc/Delete/${id}`,
};

export const LOAIYEUCAU_API = {
  GET_ALL: `${BaseGateway}/LoaiYeuCau/GetAll`,
  GET_ITEM: (id) => `${BaseGateway}/LoaiYeuCau/GetById/${id}`,
  ADD_ITEM: `${BaseGateway}/LoaiYeuCau/Create`,
  UPDATE_ITEM: (id) => `${BaseGateway}/LoaiYeuCau/Update/${id}`,
  DELETE_ITEM: (id) => `${BaseGateway}/LoaiYeuCau/Delete/${id}`,
};

export const HOTRO_API = {
  GET_ALL: `${BaseGateway}/HoTro/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/HoTro/GetById/${id}`,
  CREATE: `${BaseGateway}/HoTro/Create`,
  UPDATE: (id) => `${BaseGateway}/HoTro/UpdateItem/${id}`,
  DELETE: (id) => `${BaseGateway}/HoTro/DeleteItem/${id}`,
  GET_ALL_PAGING: `${BaseGateway}/HoTro/GetAllByPaging`,
};

export const YEUCAU_API = {
  GET_ALL: `${BaseGateway}/YeuCaus/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/YeuCaus/GetById/${id}`,
  CREATE: `${BaseGateway}/YeuCaus/Create`,
  UPDATE: (id) => `${BaseGateway}/YeuCaus/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/YeuCaus/Delete/${id}`,
  GET_ALL_PAGING: `${BaseGateway}/YeuCaus/GetAllPaging`,
  // file endpoints
  ADD_FILE: `${BaseGateway}/YeuCaus/AddFile`, // POST to AddFile/{yeuCauId}
  DELETE_FILE: `${BaseGateway}/YeuCaus/DeleteFile`, // DELETE to DeleteFile/{fileId}
  GET_FILES_BY_YEUCAU: (id) => `${BaseGateway}/YeuCaus/GetFilesByYeuCauId/${id}`,
  DOWNLOAD_FILE: (fileId) =>
    `${BaseGateway}/YeuCaus/DownloadFile/${fileId}/download`,
};

// Thống kê APIs (breakdown + summary)
export const THONGKE_API = {
  HOTRO: `${BaseGateway}/ThongKe/ThongKeHoTroChiTiet`,
  HOTRO_SUMMARY: `${BaseGateway}/ThongKe/HoTroSummary`,
  YEUCAU: `${BaseGateway}/ThongKe/ThongKeYeuCauChiTiet`,
  YEUCAU_SUMMARY: `${BaseGateway}/ThongKe/YeuCauSummary`,
};

export const CONGVIEC_API = {
  GET_ALL: `${BaseGateway}/CongViec/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/CongViec/GetById/${id}`,
  GET_BY_PROJECT_STEP: (projectStepId) =>
    `${BaseGateway}/CongViec/GetByProjectStep/${projectStepId}`,
  CREATE: `${BaseGateway}/CongViec/Create`,
  UPDATE: (id) => `${BaseGateway}/CongViec/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/CongViec/Delete/${id}`,
};

export const TASK_ASSIGNMENT_API = {
  GET_ALL: `${BaseGateway}/TaskAssignment/GetAll`,
  CREATE: `${BaseGateway}/TaskAssignment/Create`,
  UPDATE: (id) => `${BaseGateway}/TaskAssignment/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/TaskAssignment/Delete/${id}`,
  BY_ID: (id) => `${BaseGateway}/TaskAssignment/GetById/${id}`,
  GET_BY_CONGVIEC: (congViecId) =>
    `${BaseGateway}/TaskAssignment/GetByCongViec/${congViecId}`,
  GET_BY_NHANVIEN: (nhanVienId) =>
    `${BaseGateway}/TaskAssignment/GetByNhanVien/${nhanVienId}`,
};

export const NHIEMVUKHAC_API = {
  GET_ALL: `${BaseGateway}/NhiemVuKhac/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/NhiemVuKhac/GetById/${id}`,
  CREATE: `${BaseGateway}/NhiemVuKhac/Create`,
  UPDATE: (id) => `${BaseGateway}/NhiemVuKhac/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/NhiemVuKhac/Delete/${id}`,
  GET_ALL_PAGING: `${BaseGateway}/NhiemVuKhac/GetAllByPaging`,
  ADD_FILE: (nhiemVuKhacId) => `${BaseGateway}/NhiemVuKhac/AddFile/${nhiemVuKhacId}`,
  DELETE_FILE: (fileId) => `${BaseGateway}/NhiemVuKhac/DeleteFile/${fileId}`,
  GET_FILES_BY_NHIEMVUKHAC: (id) => `${BaseGateway}/NhiemVuKhac/GetFilesByNhiemVuKhacId/${id}`,
  DOWNLOAD_FILE: (fileId) => `${BaseGateway}/NhiemVuKhac/DownloadFile/${fileId}/download`,
};

export const CONGVIECKHAC_API = {
  GET_BY_ID: (id) => `${BaseGateway}/CongViecKhacs/GetById/${id}`,
  CREATE: `${BaseGateway}/CongViecKhacs/Create`,
  UPDATE: (id) => `${BaseGateway}/CongViecKhacs/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/CongViecKhacs/Delete/${id}`,
  GET_BY_NHIEM_VU: (nhiemVuId) => `${BaseGateway}/CongViecKhacs/GetAll/${nhiemVuId}`,
};

export const NHIEMVUCANHAN_API = {
  DEBUG_CURRENT_USER: `${BaseGateway}/NhiemVuCaNhan/DebugCurrentUser`,
  GET_PROJECT_TASKS: `${BaseGateway}/NhiemVuCaNhan/GetMyProjectTasks`,
  GET_OTHER_TASKS: `${BaseGateway}/NhiemVuCaNhan/GetMyOtherTasks`,
  GET_YEU_CAU_TASKS: `${BaseGateway}/NhiemVuCaNhan/GetMyYeuCauTasks`,
  GET_HO_TRO_TASKS: `${BaseGateway}/NhiemVuCaNhan/GetMyHoTroTasks`,
};

export const NGUOIPHOIHOP_API = {
  GET_ALL: `${BaseGateway}/NguoiPhoiHop/GetAll`,
  GET_BY_ID: (id) => `${BaseGateway}/NguoiPhoiHop/GetById/${id}`,
  CREATE: `${BaseGateway}/NguoiPhoiHop/Create`,
  UPDATE: (id) => `${BaseGateway}/NguoiPhoiHop/Update/${id}`,
  DELETE: (id) => `${BaseGateway}/NguoiPhoiHop/Delete/${id}`,
  GET_ALL_PAGING: `${BaseGateway}/NguoiPhoiHop/GetAllByPaging`,
};

export const BAOCAO_API = {
  GET_TONG_QUAN_TEAM: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoTongQuanTheoTeam${qs ? `?${qs}` : ''}`;
  },

  GET_THANH_VIEN_TEAM: (params = {}) => {
    const { teamId, From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    sp.append('teamId', String(teamId ?? 0));
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    return `${BaseGateway}/BaoCao/GetBaoCaoThanhVienTheoTeam?${sp.toString()}`;
  },

  GET_CHI_TIET_NHAN_VIEN: (filter = {}) => {
    const sp = new URLSearchParams();

    Object.keys(filter || {}).forEach((k) => {
      const v = filter[k];
      if (v === null || v === undefined || v === '') return;
      sp.append(k, String(v));
    });

    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietNhanVien?${sp.toString()}`;
  },

  GET_CHI_TIET_PHAT_TRIEN_PHAN_MEM: (paramsOrTeamId = {}) => {
    let params = {};
    if (paramsOrTeamId && typeof paramsOrTeamId === 'object') {
      params = paramsOrTeamId;
    } else {
      params = { teamId: paramsOrTeamId };
    }

    const { teamId, From = '', To = '' } = params || {};

    const sp = new URLSearchParams();

    if (teamId !== null && teamId !== undefined && teamId !== '') {
      sp.append('teamId', String(teamId));
    }
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietPhatTrienPhanMem${qs ? `?${qs}` : ''}`;
  },

  GET_CHI_TIET_XU_LY_YEU_CAU: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietXuLyYeuCau${qs ? `?${qs}` : ''}`;
  },

  GET_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN: (filter = {}) => {
    const sp = new URLSearchParams();

    Object.keys(filter || {}).forEach((k) => {
      const v = filter[k];
      if (v === null || v === undefined || v === '') return;
      sp.append(k, String(v));
    });
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietXuLyYeuCauByNguoiDung?${sp.toString()}`;
  },

  GET_CHI_TIET_HO_TRO: (params = {}) => {
    const { From = '', To = '' } = params || {};
    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));
    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietHoTro${qs ? `?${qs}` : ''}`;
  },

  GET_CHI_TIET_HO_TRO_THANH_VIEN: (filter = {}) => {
    const sp = new URLSearchParams();
    Object.keys(filter || {}).forEach((k) => {
      const v = filter[k];
      if (v === null || v === undefined || v === '') return;
      sp.append(k, String(v));
    });
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietHoTroByNguoiDung?${sp.toString()}`;
  },

  GET_CHI_TIET_NHIEM_VU_KHAC: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietNhiemVuKhac${qs ? `?${qs}` : ''}`;
  },

  GET_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN: (filter = {}) => {
    const sp = new URLSearchParams();
    Object.keys(filter || {}).forEach((k) => {
      const v = filter[k];
      if (v === null || v === undefined || v === '') return;
      sp.append(k, String(v));
    });

    return `${BaseGateway}/BaoCao/GetBaoCaoChiTietNhiemVuKhacByNhanVien?${sp.toString()}`;
  },

  GET_TONG_HOP_NHAN_VIEN: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/BaoCao/GetBaoCaoTongHopNhanVien${qs ? `?${qs}` : ''}`;
  },
};

export const HOME_API = {
  GET_PHAT_TRIEN_PHAN_MEM: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/Home/GetPhatTrienPhanMem${qs ? `?${qs}` : ''}`;
  },

  GET_XU_LY_YEU_CAU: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/Home/GetXuLyYeuCau${qs ? `?${qs}` : ''}`;
  },

  GET_HO_TRO: (params = {}) => {
    const { From = '', To = '' } = params || {};

    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));

    const qs = sp.toString();
    return `${BaseGateway}/Home/GetHoTro${qs ? `?${qs}` : ''}`;
  },

  GET_NHIEM_VU_KHAC: (params = {}) => {
    const { From = '', To = '' } = params || {};
    const sp = new URLSearchParams();
    if (From) sp.append('From', String(From));
    if (To) sp.append('To', String(To));
    const qs = sp.toString();
    return `${BaseGateway}/Home/GetNhiemVuKhac${qs ? `?${qs}` : ''}`;
  },
};

export const QUANLYCONGVIEC_API = {
  GET_TONG_HOP: (filter = {}) => {
    const sp = new URLSearchParams();
    Object.keys(filter || {}).forEach((k) => {
      const v = filter[k];
      if (v === null || v === undefined || v === '') return;
      sp.append(k, String(v));
    });
    return `${BaseGateway}/QuanLyCongViec/GetAllByPaging?${sp.toString()}`;
  },
  TOGGLE_QUAN_TAM: (workItemId, moduleType) =>
    `${BaseGateway}/QuanLyCongViec/ToggleQuanTam?workItemId=${workItemId}&moduleType=${moduleType}`,
};